import type { MaybePromise } from "../MaybePromise.js";

/**
 * Similar to `$effect`, but only runs the effect once when the condition is met.
 *
 * @param condition Callback that returns `true` when the effect should be run. It captures reactive dependencies.
 * @param effect Callback that runs the effect. If synchronous, it captures dependencies.
 */
export function oneTimeEffect(condition: (this: void) => boolean, effect: (this: void) => MaybePromise<unknown>): void {
	let done = false;

	$effect(() => {
		if (!done && condition()) {
			void effect();
			done = true;
		}
	});
}
